import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { Receipt as ClaimIcon, Notifications as NotificationIcon } from '@mui/icons-material';
import { AcceptModalContentProps } from '../../types';

/**
 * Generate claim-specific accept modal content component
 * Shows "coming soon" message instead of allowing claim generation
 */
export const GenerateClaimAcceptance: React.FC<AcceptModalContentProps> = ({
  context,
  onAccept,
  onCancel,
  isLoading = false,
}) => {
  const { action } = context;

  // Type guard to ensure we have the correct action data
  if (action.action_type !== 'billing_codes') {
    console.error('GenerateClaimAcceptance received wrong action type');
    return null;
  }

  const handleAccept = () => {
    // Accept the action with the payload (which includes any edits from ACCEPT_WITH_EDITS)
    onAccept(action.action_id, action.action_payload);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <ClaimIcon color="primary" />
        <Typography variant="h6" color="text.primary">
          Generate Claim
        </Typography>
      </Box>

      {/* Coming Soon Message */}
      <Alert severity="info" icon={<NotificationIcon fontSize="inherit" />} sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Thank you for your interest!
        </Typography>
        <Typography variant="body1">
          Our billing features are coming soon! We'll notify you when the feature goes live.
        </Typography>
      </Alert>

      {/* Actions */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          pt: 2,
          borderTop: 1,
          borderColor: 'divider',
        }}
      >
        <Button onClick={onCancel} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleAccept}
          variant="contained"
          color="primary"
          disabled={isLoading}
          startIcon={<NotificationIcon />}
        >
          Notify Me When Ready
        </Button>
      </Box>
    </Box>
  );
};
